module.exports = __webpack_public_path__ + "static/media/CanvasType.7ae9d47e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CanvasType.jpg
// module id = 1712
// module chunks = 0